import * as types from './types';
import { createRoutine, promisifyRoutine } from 'redux-saga-routines';

export const fetchProduct = createRoutine(types.FETCH_PRODUCT);
export const fetchProductsPage = createRoutine(types.FETCH_PRODUCTS);
export const createProduct = createRoutine(types.CREATE_PRODUCT);
export const sumbmitCreateProductForm = promisifyRoutine(createProduct);
export const updateProduct = createRoutine(types.UPDATE_PRODUCT);
export const sumbmitUpdateProductForm = promisifyRoutine(updateProduct);
